<template>
  <div class="ruta">
    <NavBar :transparent-on-top="true" :scroll-padding="true"></NavBar>
    <div class="background-img" :style="'background-image: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,1), rgba(0,0,0,1)), url(' + bgimg + ');'">
      <div class="top">
        <vs-row justify="center" align="end">
          <vs-col class="centrar" vs-type="flex" vs-justify="center" vs-align="center" w="3" xs="12" style="display: flex; justify-content: center">
            <img class="centrar detail-poster" :src="poster" width="90%" alt="Poster">
            <br>
            <div class="centrar">
              <ul class="centrar">
                <li>
                  <vs-tooltip bottom>
                    <vs-button icon color="danger" border>
                      <i class='bx bxs-heart bx-lg' ></i>
                    </vs-button>
                    <template #tooltip>
                      Me gusta
                    </template>
                  </vs-tooltip>
                </li>
                <li>
                  <vs-tooltip bottom>
                    <vs-button icon color="primary" border>
                      <i class='bx bxs-bookmark bx-lg' ></i>
                    </vs-button>
                    <template #tooltip>
                      Añadir a Mi Lista
                    </template>
                  </vs-tooltip>
                </li>
                <li>
                  <vs-tooltip right>
                    <vs-button icon color="rgb(255, 130, 0)">
                      <i class='bx bxs-share-alt bx-lg' ></i>
                    </vs-button>
                    <template #tooltip>
                      Compartir
                    </template>
                  </vs-tooltip>
                </li>
              </ul>
            </div>
          </vs-col>
          <vs-col class="youNeedCoolAir" vs-type="flex" vs-justify="center" vs-align="center" w="8">
            <!-- <div class="h1">{{ $route.params.name }}</div> -->
            <div class="h1">{{ title }}</div>
            <small><b>Estado:</b> {{ status }}</small><br>
            <br>
            <small>{{ description }}</small>
          </vs-col>
        </vs-row>
      </div>
    </div>
    <div class="tableData">
      <vs-table>

        <template #thead>
          <vs-tr>
            <vs-th sort @click="capitulos = $vs.sortData($event, capitulos, 'number')">
              #
            </vs-th>
            <vs-th sort @click="capitulos = $vs.sortData($event, capitulos, 'nombre')">
              Nombre
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="i"
              v-for="(tr, i) in $vs.getSearch(capitulos, '')"
              :data="tr"
          >
            <vs-td>
              {{ tr.number }}
            </vs-td>
            <vs-td>
              {{ tr.nombre }}
            </vs-td>
            <template #expand>
              <div class="con-content">
                <ul>
                  <li v-for="(link, index) in tr.options" v-bind:key="link.uuid">
                    <vs-button primary @click="openModal(link.uuid)">
                      Opción {{ index + 1 }}: {{ link.publisher }}
                    </vs-button>
                  </li>
                </ul>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="others" style="margin-top: 5%">
      <b>Otras novelas ligeras así...</b>
      {novelasligeras}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavBar from "../components/NavBar";

export default {
  name: "BookDetail",
  components: {NavBar},
  data() {
    return {
      isFetching: true,
      title: 'Sin título',
      description: 'Sin descripción',
      bgimg: 'https://i.imgur.com/Zx6wTMp.png',
      status: null,
      poster: 'https://i.imgur.com/1tg211q.png',
      // idLibro: null,
      capitulos: {}
    }
  },
  methods: {
    openModal(uuid) {
      window.open(window.location.origin + '/lectorem/reader/' + uuid, "Reader VIDENTI", "scrollbars=NO");
    }
  },
  async created() {
    const loading = this.$vs.loading({
      background: '#000',
      color: '#fff',
      text: 'Cargando...'
    })
    await axios
        .get('https://api.videnti.co/lectorem/getBookInfo/' + this.$route.params.titulo)
        .then(response => {
          if (!response.data[0]) {
            window.location = '../?error=LIBRO_NO_EXISTE';
          }
          this.title = response.data[0].nombre;
          this.description = response.data[0].descripcion;
          if (response.data[0].poster_horizontal) {
            this.bgimg = response.data[0].poster_horizontal;
          }
          switch (response.data[0].status) {
            case 0:
              this.status = "Activo"
              break;
            case 1:
              this.status = "Finalizado";
              break;
            case 2:
              this.status = "Hiatus";
              break;
          }
          this.poster = response.data[0].poster_vertical;
          // this.idLibro = response.data[0].id;
        }).catch(error => console.log(error));
    await axios
        .get('https://api.videnti.co/lectorem/getBookChapters/' + this.$route.params.titulo)
        .then(resTemp => {
          this.capitulos = resTemp.data;
          /* this.capitulos.forEach((obj, index) => {
            console.log('Searching for UUIDs for chapter: ' + obj.number + " v3.");
            axios.get('https://api.videnti.co/lectoremUUIDsByIdCapitulo/' + obj.idLibroCapitulo)
                .then(resUUID => this.capitulos[index].links = resUUID.data);
          }); */
        });
    loading.close();
  }
}
</script>

<style scoped lang="scss">
@import "~@elbuenanvita/vuesax/src/styles/mixins";

img.detail-poster {
  width: 80%;

  @include media-breakpoint-down("sm") {
    width: 50%;
  }
}

.background-img {
  background: {
    position: center;
    size: cover;
  };
  min-height: 75%;
  top: 0; left: 0; right: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  color: #FFF;
}

.top {
  padding: {
    /* left: 6rem; */
    top: 6rem;
    bottom: 1rem;
    /* bottom: 5%; */
  }
  /* padding-left: 20%;
  padding-top: 5%;
  padding-bottom: 5%; */
  /* height: 100%; */
}
.h1 {
  text-decoration: none;
  font-size: 25pt;
  font-weight: bold;
}
.episodes {
  margin-top: -100px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.vs-alert {
  margin-bottom: 10px;
}

.vs-card__img {
  display: block;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
}

.thumbNail:after {
  content: "";
  display: block;
  padding-top: 56.25%;
}

@media only screen and (max-width: 645px) {
  .top {
    padding-left: 5%;
  }
  .youNeedCoolAir {
    padding-left: 5%;
  }
}

.vs-table__tr.isExpand:first-of-type .vs-table__td {
  background: #2c3e50 !important;
}

.vs-table__thead .vs-table__th {
  background: #303030 !important;
}

.vs-table__tr:hover .vs-table__td {
  background: #2c3e50 !important;
}

article {
  position: static !important;
}

.tableData {
  margin-left: 10%;
  margin-right: 10%;
}

.others {
  padding-left: 5%;
  padding-right: 5%;
}
</style>

<style>
.vs-table__tr.isExpand:first-of-type .vs-table__td {
  background: #2c3e50 !important;
}

.vs-table__thead .vs-table__th {
  background: #303030 !important;
}

.vs-table__tr:hover .vs-table__td {
  background: #2c3e50 !important;
}

.tableData .vs-table-content .vs-table {
  height: auto !important;
  padding-top: 4%;
}

.vs-table__tr__expand td {
  background: #2c3e50 !important;
}

.vs-table__tr.isExpand:not(:first-of-type) .vs-table__td {
  background: #2c3e50 !important;
}

td.vs-table__expand__td {
  border-radius: 0px 0px 15px 15px !important;
}
</style>
